import { render, staticRenderFns } from "./PopupAgreement.vue?vue&type=template&id=f02b50d2"
import script from "./PopupAgreement.vue?vue&type=script&lang=ts"
export * from "./PopupAgreement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports